import React from 'react';
import { bool } from 'prop-types';

import Paper from '@material-ui/core/Paper';

import classes from './ConversionPanel.module.css';

import ConversionAddForm from './ConversionAddForm';
import ConversionEditForm from './ConversionEditForm';

const ConversionPanel = ({ formType, onDeleteConversion }) => {
    let content;

    switch (formType) {
        case 'add':
            content = <ConversionAddForm />;
            break;
        case 'edit':
            content = (
                <ConversionEditForm onDeleteConversion={onDeleteConversion} />
            );
            break;
        default:
            content = (
                <div className={classes.selectConversionContainer}>
                    <img src="/assets/images/yoda.svg" alt="yoda icon" />
                    <h2>Select a Unit Conversion, you must!</h2>
                </div>
            );
    }

    return <Paper className={classes.ConversionPanel}>{content}</Paper>;
};

ConversionPanel.defaultProps = {
    showForm: false
};

ConversionPanel.propTypes = {
    showForm: bool
};

export default ConversionPanel;
